module.exports = require('./generated/variables');
